import { AxiosInstance } from 'axios';
import { Dictionary } from '@/types';

export enum Statuses {
  CHECKED = 'checked',
  ERROR = 'error',
  READY = 'ready',
  WAITING = 'waiting',
}

export interface Item {
  age: string;
  code?: string;
  announce: string;
  description: string;
  id: Id;
  img: string;
  name: string;
  cop_multi_name: string;
  is_locked: boolean;
}

export interface Sections {
  section: string;
  subSection: string;
}

export interface Params extends Sections {
  day: string;
  month: string;
  year: string;
}

export interface FetchParams extends Sections {
  day: number;
  month: number;
  year: number;
  pageNumber: number;
  pageSize: number;
}

export interface Providers {
  $api: AxiosInstance;
  $config: Dictionary<any>;
}

export interface State extends FetchParams {
  items: Items;
  status: Statuses;
  count: number;
  limit: number;
  page: number;
}

export interface ActivitiesResponse {
  data: Items;
  filtered: string | number;
  limit: string | number;
  page: string | number;
}

export type Items = Array<Item>;
export type Id = string | number;
export type Url = string;



// WEBPACK FOOTER //
// ./src/pages/activities/day/types.ts